import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import NavigationBar from "../NavigationBar";
import { useLocation, useNavigate } from "react-router-dom";

function createHeaderStyle(pathName: string) {
  switch (true) {
    case pathName === "/":
      return {
        headerBg: "bg-black/80 backdrop-blur-sm",
        textColor: "text-white",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-white",
        headerImages: "/assets/images/main_logo_white.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };
    case pathName === "/mpaper":
      return {
        headerBg: "bg-white/80 backdrop-blur-sm",
        textColor: "text-black",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-black",
        headerImages: "/assets/images/main_logo.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };
    case pathName === "/mkt":
      return {
        headerBg: "bg-white/80 backdrop-blur-sm",
        textColor: "text-black",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-black",
        headerImages: "/assets/images/main_logo.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };
    case pathName === "/contact":
      return {
        headerBg: "bg-white/80 backdrop-blur-sm",
        textColor: "text-black",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-black",
        headerImages: "/assets/images/main_logo.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };
    case pathName.startsWith("/news/"):
      return {
        headerBg: "bg-black/80 backdrop-blur-sm",
        textColor: "text-white",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-white",
        headerImages: "/assets/images/main_logo_white.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };

    default:
      return {
        headerBg: "bg-black/80 backdrop-blur-sm",
        textColor: "text-white",
        hoverColor: "hover:text-gray-400",
        submenuTextColor: "text-black",
        menuColor: "text-black",
        headerImages: "/assets/images/main_logo.png",
        submenuHoverTextColor: "hover:text-gray-400",
      };
  }
}

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const styles = createHeaderStyle(location.pathname);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const didShowMainPage = () => {
    navigate(`/`);
  };

  return (
    <>
      <header className={`${styles.headerBg} fixed inset-x-0 top-0 z-50`}>
        <div className="container mx-auto flex items-center justify-between py-4 px-5">
          <button className="main-header-logo" onClick={didShowMainPage}>
            <img
              src={`${styles.headerImages}`}
              className="w-[138px] h-[56px]"
            />
          </button>

          <nav className="hidden desktop:flex">
            <NavigationBar
              subtitles={[
                "회사소개",
                "전자영수증",
                "디지털 마케팅",
                "문의하기",
              ]}
              hrefs={["/", "/mpaper", "/mkt", "/contact"]}
              onNavigate={() => setIsOpen(false)}
              textColor={styles.textColor}
              hoverColor={styles.hoverColor}
              submenuTextColor={styles.submenuTextColor}
              submenuHoverColor={styles.submenuHoverTextColor}
            />
          </nav>

          <button
            className={`desktop:hidden ${styles.menuColor}`}
            onClick={() => setIsOpen((o) => !o)}
            aria-label="메뉴 토글"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm desktop:hidden"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="absolute right-0 top-0 w-3/4 max-w-xs h-full bg-white p-6 overflow-y-auto shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-gray-600"
              onClick={() => setIsOpen(false)}
              aria-label="메뉴 닫기"
            >
              <X size={24} />
            </button>
            <NavigationBar
              isMobile
              subtitles={[
                "회사소개",
                "전자영수증",
                "디지털 마케팅",
                "문의하기",
              ]}
              hrefs={["/", "/mpaper", "/mkt", "/contact"]}
              onNavigate={() => setIsOpen(true)}
            />
          </div>
        </div>
      )}
    </>
  );
}
